var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#62CDB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.774 7.36679C15.1237 7.79424 15.0607 8.42426 14.6332 8.77399L8.43282 13.8471L5.29289 10.7071C4.90237 10.3166 4.90237 9.68345 5.29289 9.29292C5.68342 8.9024 6.31658 8.9024 6.70711 9.29292L8.56718 11.153L13.3668 7.22607C13.7942 6.87635 14.4242 6.93935 14.774 7.36679Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYes);
export default __webpack_public_path__ + "static/media/icon-yes.53d963bdf6c1d7c52e0d21605c1c9283.svg";
export { ForwardRef as ReactComponent };